export type ValidationEntry<T> = (value: unknown) => T;

export const boolean =
  (initial: boolean): ValidationEntry<boolean> =>
  (value) => {
    return typeof value === "boolean" ? value : initial;
  };
